import { ThreeView } from "../View3dWebCad";
import * as THREE from 'three';
import { ModelDragController } from "./ModelDragController";
import { ModelRotateController } from "./ModelRotateController";
import { webcadDefines } from "..";
import { EventDispatcher } from "three/src/core/EventDispatcher";
import * as marietta from '../../../../marietta';
import { BBOXManager } from "../BBOXManager";
import { ObjectType } from "../ObjectType";

export class ItemDragManager extends EventDispatcher {
    public enabled: boolean = true;
    public handlers: any[];

    public target: THREE.Object3D;          // 選択形状
    public intersectPoint: THREE.Vector3;   // 選択位置

    private BBOXManager: BBOXManager;

    public dragController: ModelDragController;
    public rotateController: ModelRotateController;

    public selectObj: THREE.Object3D;

    public previousStatus: State;

    constructor() {
        super();
        this.boundingbox();
    }

    public showBBOX() {
        this.BBOXManager.showBox();
    }

    public hideBBOX() {
        this.BBOXManager.hideBox();
    }
    // bouding boxの作成
    private boundingbox() {
        // 選択可能なBBOX 作成
        this.BBOXManager = new BBOXManager('選択可能形状 BBOX', new THREE.Color(0xffffff));
    }

    private showhideBBOX(hitObj: THREE.Intersection[]) {
        if (hitObj.length > 0 && ObjectType.isItemSelected(hitObj[0].object)) {
            const object = ObjectType.getItem(hitObj[0].object);
            this.BBOXManager.showBox();
            this.BBOXManager.reSize(object);
            // 選択形状があって、マウスカーソル下の形状と同じ形状ならBBOX非表示
            if (this.selectObj && this.selectObj.uuid == object.uuid) {
                this.BBOXManager.hideBox();
            }
        } else {
            this.BBOXManager.hideBox();     // レイキャストして当たる形状がなければBBOX非表示
        }
    }

    private hit(hitObj: THREE.Intersection[]) {
        const hit = (hitObj.length && ObjectType.isItemSelected(hitObj[0].object));

        this.target  = hit ? ObjectType.getItem(hitObj[0].object) : null;
        this.intersectPoint = hit ? hitObj[0].point : null;
    }

    public down = (hitObj: THREE.Intersection[]) => {
        if (!this.enabled) return;
        this.BBOXManager.hideBox();

        this.hit(hitObj);

        if (this.previousStatus) this.previousStatus.execute_down();
        this.previousStatus = new downState(this);
    }

    // moveの処理
    public move(hitObj: THREE.Intersection[]) {
        if (!this.enabled) return;

        this.showhideBBOX(hitObj);

        if (this.previousStatus) this.previousStatus.execute_move();
        this.previousStatus = new moveState(this);
    }

    public up = () => {
        if (!this.enabled) return;

        if ( this.previousStatus ) this.previousStatus.execute_up();
        this.previousStatus = new upState(this);
    }

    public reset() {
        this.resetController();
        this.BBOXManager.remove();
    }

    // pinの壁判定
    public isPinWallItem(): boolean {
        // return ThreeView.get().wallSelectManager.type == webcadDefines.ExtrasSubType.INNERWALL;
        return this.selectObj.userData.modelInfo.subType == webcadDefines.ExtrasSubType.INNERWALL;
    }

    // pinの天井判定
    public isPinCeilingItem(): boolean {
        // return ThreeView.get().wallSelectManager.type == webcadDefines.ExtrasSubType.CEILING;
        return this.selectObj.userData.modelInfo.subType == webcadDefines.ExtrasSubType.CEILING;
    }

    // 家具・住設・外構の壁アイテム判定
    public isWallItem(): Boolean {
        if (ObjectType.isPin(this.selectObj)) return this.isPinWallItem();
        return marietta.webcad.WebCADGlobal.doesItemSupportZPositioning(this.selectObj.userData.modelInfo.code);
    }

    // 家具・住設・外構の天井アイテム判定
    public isCeilingItem(): Boolean {
        if (ObjectType.isPin(this.selectObj)) return this.isPinCeilingItem();
        return marietta.webcad.WebCADGlobal.IsCeilingItem(this.selectObj.userData.modelInfo.code);
    }

    public setController() {
        if (this.dragController) this.dragController.removeEvent();
        if (this.rotateController) this.rotateController.removeEvent();
        this.dragController = new ModelDragController(this.selectObj, this.isWallItem());
        this.rotateController = new ModelRotateController(this.selectObj);

        this.dispatchEvent( { type: webcadDefines.WebCadEventNames.selectedObject, object: this.target, point: this.intersectPoint } );
    }

    public resetController() {
        this.selectObj = null;
        if (this.dragController) this.dragController.removeEvent();
        if (this.rotateController) this.rotateController.removeEvent();
        this.dragController = undefined;
        this.rotateController = undefined;
        this.dispatchEvent( { type: webcadDefines.WebCadEventNames.unSelectedObject } );
    }

    public checkController(): boolean {
        if (this.dragController == null) return false;
        return this.dragController.isMouseDown;
    }

    public checkController_(): boolean {
        if (this.rotateController == null) return false;
        return this.rotateController.isMouseDown;
    }
}

// move: hover
// down 形状選択　→ up: select (選択状態の形状以外を選択の時)
// down 形状選択　→ move（選択状態の形状だった場合）: drag → up: dragend
// down 形状選択（選択状態の形状以外）・非選択　→ move: パン
// down 形状非選択　→　up: unSelect

export class State {

    public itemdragmanager: ItemDragManager;

    constructor(itemdragmanager: ItemDragManager) {
        this.itemdragmanager = itemdragmanager;
    }

    public execute_down() {}
    public execute_move() {}
    public execute_up() {}

    //形状の選択とコントローラのセット
    public setSelectObject() {
        this.itemdragmanager.selectObj = this.itemdragmanager.target;
        this.itemdragmanager.setController();
    }

    public resetController() {
        this.itemdragmanager.resetController();
    }

    //コントローラーが反応しているか
    public checkController(): boolean {
        return this.itemdragmanager.checkController();
    }
    public checkController_(): boolean {
        return this.itemdragmanager.checkController_();
    }
}

export class downState extends State {
    constructor(itemdragmanager: ItemDragManager) {
        super(itemdragmanager);
    }

    public execute_up() {
        // 選択
        if (this.itemdragmanager.target) {
            if (this.itemdragmanager.selectObj == null) {
                this.setSelectObject();     // 新しく形状を選択状態にする
            }
            // 前に選択状態の形状が存在しているとき
            if (this.itemdragmanager.selectObj && this.itemdragmanager.target.uuid != this.itemdragmanager.selectObj.uuid) {
                this.resetController();     // 前の形状の選択を解除
                this.setSelectObject();     // 選択状態の形状をセット
            }
        } else {
        // 非選択
            if (this.checkController() == false && this.checkController_() == false) {
                this.itemdragmanager.selectObj = undefined;
                this.resetController();
            }
        }
    }
}

export class moveState extends State {
    constructor(public itemdragmanager: ItemDragManager) {
        super(itemdragmanager);
    }
}

export class upState extends State {
    constructor(public itemdragmanager: ItemDragManager) {
        super(itemdragmanager);
    }
}
